<template>
  <div class="glod-list-box">
    <!--操作栏-->
    <div class="action-bar">
      <el-select
          v-model="query.type"
          size="small"
          placeholder="请选择货币类型"
          clearable
          @change="getCurrencyList"
      >
        <el-option
            v-for="item in currencyType"
            :value="item.value"
            :label="item.label"
            :key="item.value"
        ></el-option>
      </el-select>
      <el-select
          v-model="query.isActive"
          size="small"
          placeholder="请选择激活状态"
          clearable
          @change="getCurrencyList"
      >
        <el-option
            v-for="item in activeType"
            :value="item.value"
            :label="item.label"
            :key="item.value"
        ></el-option>
      </el-select>
      <el-button type="primary" size="small" @click="getCurrencyList" style="margin-right: 10px">搜索
      </el-button>
      <el-button type="primary" size="small" @click="Action('add')" class="add-input">+新增配置</el-button>
    </div>
    <!--数据表格-->
    <el-table :data="tableData" style="width: 100%" border v-loading="loading" element-loading-text="拼命加载中"
              element-loading-spinner="el-icon-loading" ref="multipleTable">
      <el-table-column prop="id" label="ID" align="center" fixed min-width="200">
        <template slot-scope="scope">
          <span>{{ scope.row.id }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="name" label="货币名称" align="center" fixed min-width="150">
        <template slot-scope="scope">
          <span>{{ scope.row.name }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="type" label="货币类型" align="center" min-width="150">
        <template slot-scope="scope">
          <el-tag type="success">{{ currencyTypeParse(scope.row.type) }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="coins" label="货币数量" align="center" min-width="150">
        <template slot-scope="scope">
          <span>{{ scope.row.coins }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="price" label="价格(分)" align="center" min-width="150">
        <template slot-scope="scope">
          <span>{{ scope.row.price }}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="giveFruitCoin" label="赠送果币" align="center" min-width="150">
        <template slot-scope="scope">
          <span>{{ scope.row.giveFruitCoin }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="giveGold" label="赠送金币" align="center" min-width="150">
        <template slot-scope="scope">
          <span>{{ scope.row.giveGold }}</span>
        </template>
      </el-table-column> -->
      <el-table-column v-if="isGameGold" prop="couponDesc" label="优惠描述" align="center" min-width="150">
        <template slot-scope="scope">
          <span>{{scope.row.couponDesc || '-'}}</span>
        </template>
      </el-table-column>
      <el-table-column v-if="isGameGold" prop="louFengUnlockTimes" label="楼凤解锁次数" align="center" min-width="150">
        <template slot-scope="scope">
          <span>{{scope.row.louFengUnlockTimes || '-'}}</span>
        </template>
      </el-table-column>
      <el-table-column v-if="isGameGold" prop="giveVipDays" label="赠送vip天数" align="center" min-width="150">
        <template slot-scope="scope">
          <span>{{scope.row.giveVipDays || '-'}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="giveFruitCoin" label="赠送果币" align="center" min-width="150">
        <template slot-scope="scope">
          <span>{{scope.row.giveFruitCoin || '-'}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="giveGameCoin" label="赠送游戏金币" align="center" min-width="150">
        <template slot-scope="scope">
          <span>{{scope.row.giveGameCoin || '-'}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="giveGold" label="赠送金币" align="center" min-width="150">
        <template slot-scope="scope">
          <span>{{scope.row.giveGold || '-'}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="firstGiveVipDays" label="首次赠送vip天数" align="center" min-width="150">
        <template slot-scope="scope">
          <span>{{scope.row.firstGiveVipDays || '-'}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="firstGiveGameCoin" label="首次赠送游戏金币" align="center" min-width="150">
        <template slot-scope="scope">
          <span>{{scope.row.firstGiveGameCoin || '-'}}</span>
        </template>
      </el-table-column>
      <el-table-column v-if="isGameGold" prop="notFirst" label="非首充赠送" align="center" min-width="150">
        <template slot-scope="scope">
          <el-switch v-model="scope.row.notFirst" active-text="开启" inactive-text="关闭" disabled>
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="状态" align="center" min-width="150">
        <template slot-scope="scope">
          <el-switch v-model="scope.row.isActive" active-text="上架" inactive-text="下架" disabled>
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column prop="createdAt" label="创建时间" align="center" min-width="240">
        <template slot-scope="scope">
          <span>{{ scope.row.createdAt | changeDate}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="updateAt" label="刷新时间" align="center" min-width="240">
        <template slot-scope="scope">
          <span>{{ scope.row.updatedAt | changeDate}}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" fixed="right" min-width="120">
        <template slot-scope="scope">
          <el-button type="success" size="mini" icon="el-icon-edit"
                     @click="Action('edit',scope.row)"></el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--分页组件-->
    <el-pagination :page-sizes="[10, 15, 20, 30]" :current-page="query.pageNumber" :page-size="query.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" background v-if="total > 10" @size-change="changeSize" @current-change="changeCurrent"></el-pagination>
    <!--新增、编辑弹框-->
    <CurrencyAction ref="Action" @handlerGoldList="getCurrencyList()"></CurrencyAction>
  </div>
</template>

<script>
import API from '@/api'
import CurrencyAction from "./components/currencyAction"

export default {
  data() {
    return {
      // 表格数据加载动画
      loading: false,
      isGameGold: false,
      // 列表数据
      tableData: [],
      total: 0,
      currencyType: [
        {label: '金币', value: 1},
        {label: '游戏币', value: 2},
        {label: '果币', value: 3},
      ],
      activeType: [
        {label: '激活', value: true},
        {label: '未激活', value: false},
        {label: '全部', value: undefined},
      ],
      // 请求参数
      query: {
        pageNumber: 1,
        pageSize: 10,
        type: 1,
        isActive: undefined,
      },
    }
  },
  components: {
    CurrencyAction
  },
  created() {
    this.getCurrencyList()
  },
  methods: {
    currencyTypeParse(type) {
      switch (type) {
        case 1:
          return "金币"
        case 2:
          return "游戏币"
        case 3:
          return "果币"
      }
    },
    // 请求货币列表
    getCurrencyList() {
      this.loading = true;
      if (this.query.type === 2) {
        this.isGameGold = true
      } else {
        this.isGameGold = false
      }
      API.getCurrencyList(this.query).then(res => {
        if (res.code === 200 && res.data) {
          this.tableData = res.data.data;
          this.total = res.data.total;
        } else {
          this.tableData = []
        }
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    // 新增、编辑操作
    Action(type, data) {
      this.$refs.Action.open(type, data)
    },
    // 分页条数改变回掉
    changeSize(size) {
      this.query.pageSize = size;
      this.getCurrencyList();
    },
    // 当前页发生变化触发
    changeCurrent(pageNumber) {
      this.query.pageNumber = pageNumber;
      this.getCurrencyList();
    },
  }
}
</script>

<style lang="scss">
.gold-list-box {
  .add-input {
    margin-left: 0 !important;
  }
}
</style>
